import ScopedAdminPage from "../components/ScopedAdminPage.jsx";
import PushNotificationsPanel from "../components/notifications/PushNotificationsPanel.jsx";
import { hasPermission, useMyPermissions } from "../lib/permissions.js";
import { PERMISSIONS } from "../lib/permissionKeys.js";

export default function NotificationsPage({ viewDef }) {
    // Delete alone needs `manage`; `manage` implies `write` but not the
    // reverse, so a custom role can hold write without it. The view's nav
    // gate already required write to get here.
    const caps = useMyPermissions();
    const canManage = hasPermission(caps, PERMISSIONS.INTEGRATIONS_MANAGE);
    return (
        <ScopedAdminPage
            title={viewDef?.label ?? "Notifications"}
            scope="Organization-wide"
            description="Send Origin detections to the tools your team already uses. Destinations here deliver for the whole tenant, not only for your account."
        >
            <PushNotificationsPanel canManage={canManage} />
        </ScopedAdminPage>
    );
}
